import { ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AppSettings } from './../../app.settings';
import { StorageService } from './../../services/storage.service';
import { SidebarService } from './../../services/sidebar.service';
import { Subscription } from 'rxjs';
import { UiService } from '../../services/ui.service';
import { CommonBindingDataService } from '../../services/common-binding-data.service';


@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    standalone: false
})
export class SidebarComponent implements OnInit, OnDestroy {
  items: MenuItem[];
  subscription: Subscription;
  user;
  profileSubscription: Subscription;
  poweredByLogo = '/assets/images/temp/powered-by-logo.png';
  updateType: any;
  displayVersion: any = '';
  currentVersion: any = '';
  newVersion: any = '';
  latestVersionObj: any = '';
  whatsNew: any = '';
  isUpdateAvailable = false;
  AppVersionHistoryRefreshInterval;
  buildVersion: any;


  constructor(private storageService: StorageService,
    private sidebarService: SidebarService,
    private uiService: UiService,
    private commonBindingDataService: CommonBindingDataService,
    private cdr: ChangeDetectorRef
  ) { }


  ngOnInit() {
    // this.poweredByLogo = this.commonBindingDataService.getPoweredByLogoFromMetadata();
    this.initSidebarItems();
    this.subscription = this.sidebarService.sideState
      .subscribe((state: any) => {
        this.updateItems(state);
      });

    this.profileSubscription = this.uiService.profileUpdatedEvent.subscribe((state: any) => {
      this.initSidebarItems();
    });
    this.commonBindingDataService.redrawSidebar.subscribe(() => {
      this.initSidebarItems();
    });

    this.buildVersion = this.storageService.getItem(AppSettings.WEB_VERSION);
    if (this.buildVersion) {
      this.displayVersion = this.buildVersion.version;
      this.currentVersion = this.buildVersion.version;
      this.cdr.detectChanges();
      this.AppVersionHistoryRefreshInterval = setInterval(() => {
       this.getWebAppVersion();
     }, 60000 * 5);
    }
  }

  redirectTo() {
    document.getElementById('input').focus();
  }

  initSidebarItems() {
    this.items = [];
    this.user = this.storageService.getItem(AppSettings.USER_DETAILS);
    if (this.items.length <= 0) {
      if (this.user !== null && this.user !== undefined) {
        this.items = this.getMenu();
      }
    }
    this.updateItems();
    this.manageActiveStatus();
  }

  updateItems(state?) {
    if (state) {
      this.items = state;
    }
    this.items = this.removeDuplicates(this.items, 'label');
  }

  removeDuplicates(myArr, prop) {
    return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }


  private manageActiveStatus() {
    for (let i = 0; i < this.items.length; i++) {
      const item = this.items[i];
      if (item.routerLink) {
        if (item.routerLink.length >= 1 && document.location.pathname === item.routerLink[0]) {
          item.expanded = true;
        }
      }
    }
  }


  getMenu() {
    return this.sidebarService.sideBarMenu;
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
    clearInterval(this.AppVersionHistoryRefreshInterval);
  }

    getWebAppVersion() {
    this.commonBindingDataService.getWebAppVersion().subscribe({
      next: (result) => {
        if (this.buildVersion.version !== result.version) {
          if (result.mandatory === true || result.optional === true) {
            this.isUpdateAvailable = true;
            this.updateType = result.updateType;
            this.latestVersionObj = result;
            this.newVersion = result.version;
            this.whatsNew = result.updateDetails;
          }
          }
        },
      error: (error) => {
        // this.uiService.showMessage(AppSettings.SEVERITY.ERROR, error.general[0].message);
      }
    })
  }

  updateNow() {
    this.isUpdateAvailable = false;
    this.storageService.setItem(AppSettings.WEB_VERSION, this.latestVersionObj);
    location.reload();
  }

  updateSkipNow() {
    this.isUpdateAvailable = false;
  }

}
